<template>
  <div>


    <div>
      <div v-if="displayMode == 'grid'">
        <div>
          <button class="btn blue" type="button" @click="multiSelectMode = !multiSelectMode">
            <span v-if="multiSelectMode"><i class="fa fa-check-square-o"></i></span>
            <span v-else><i class="fa fa-square-o"></i></span>
            <span>Sélection multiple</span>
          </button>
          <button class="btn purple" type="button" v-if="selectedFiles.length > 0" @click="viewSelectedFilesPrompt">
            <i class="fa fa-search"></i>
            <span v-if="selectedFiles.length > 1">Voir {{selectedFiles.length}} documents</span>
            <span v-else>Voir le document</span>
          </button>
          <button class="btn red" type="button" v-if="selectedFiles.length > 0" @click="deleteSelectedFilesPrompt">
            <i class="fa fa-trash"></i>
            <span v-if="selectedFiles.length > 1">Supprimer {{selectedFiles.length}} documents</span>
            <span v-else>Supprimer le document</span>
          </button>
          <button class="btn orange" type="button" v-if="selectedFiles.length > 0" @click="downloadSelectedFiles">
            <i class="fa fa-download"></i>
            <span v-if="selectedFiles.length > 1">Télécharger {{selectedFiles.length}} documents</span>
            <span v-else>Télécharger le document</span>
          </button>
        </div>
        <div class="mt-2">
          <div v-for="(file, index) in files" :key="index" class="text-center file-item" :class="{'file-multi-select': multiSelectMode, 'selected': fileSelected(file)}" @click="toggleSelected($event, file)" style="width: 125px; display: inline-block; vertical-align: top; position: relative">
            <div>
              <div class="file-thumbnail">
                <img :src="fileThumbnail(file)" :alt="file.name">
              </div>
              <div class="file-title">
                {{file.name}}
              </div>
            </div>
            <div class="file-select-box">
              <span v-if="fileSelected(file)"><i class="fa fa-check-square-o"></i></span>
              <span v-else><i class="fa fa-square-o"></i></span>
            </div>
          </div>
          <div class="display: inline-block" style="width: 125px; height: 125px; vertical-align: top;" v-if="editEnabled">
            <div class="add-document-button" @click="triggerFileUpload">
              <i class="fa fa-plus"></i>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="displayMode == 'list'">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Date</th>
              <th>Nom</th>
              <th style="width: 1%; white-space: nowrap;">
                <button class="btn btn-sm blue" style="width: 100%" @click="triggerFileUpload" v-if="editEnabled">Ajouter</button>
              </th>
            </tr>
          </thead>
          <tbody v-if="files.length > 0">
            <tr v-for="(file, index) in files" :key="index">
              <td style="white-space: nowrap;">{{file.date}}</td>
              <td>{{file.name}}</td>
              <td style="width: 1%; white-space: nowrap;">
                <a class="btn btn-circle btn-icon-only btn-default tooltips" data-container="body" data-placement="top" data-original-title="Télécharger" href="javascript:;" @click="downloadOneDocument(file)">
                  <i class="glyphicon glyphicon-download"></i>
                </a>
                <a class="btn btn-circle btn-icon-only btn-default tooltips" data-container="body" data-placement="top" data-original-title="Supprimer" href="javascript:;" @click="deleteOneDocument(file)">
                  <i class="icon-trash"></i>
                </a>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="3" class="text-center">Aucun documents</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    
    <div class="uploader">
      <input type="file" ref="file-uploader" multiple>
    </div>
  </div>
</template>

<script>
import bootbox from 'bootbox';

export default {
  name: "document-manager",
  props: {
    display: {
      type: String,
      default: 'list',
    },
    endpointPrefix: {
      type: String,
      required: true,
    },
    additionnalData: {
      type: Object,
      default: () => {}
    },
    filters: {
      type: Object,
      default: () => {}
    },
    documentCounterSelector: {
      type: String,
      required: false,
    },
    documentAddButtonSelector: {
      type: String,
      required: false,
    },
    allowEdit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      files: [],
      selectedFiles: [],
      loaded: false,
      displayMode: this.display,
      multiSelectMode: false,
      editEnabled: this.allowEdit
    }
  },
  mounted () {
    let that = this;

    this.fetchList();

    this.$refs["file-uploader"].addEventListener("change", async (e) => {
      await this.uploadFiles(e.target.files);
    })

    if(this.documentAddButtonSelector != null){
      $(this.documentAddButtonSelector).on("click", () => {
        that.triggerFileUpload();
      })
    }
  },
  computed: {
    fileSelected() {
      return (file) => {
        return this.selectedFiles.find(f => f.id == file.id)
      } 
    },
    fileThumbnail() {
      return (file) => {
        return file.thumbnail ?? `${this.endpointPrefix}/thumbnail/${file.id}`;
      } 
    }
  },
  methods: {
    async fetchList() {
      try {
        let result = await $.post(`${this.endpointPrefix}/list`, {filters: this.filters});
        this.files = result;
        this.updateDocumentCounter();
      } catch {
        toastr.error("Une erreur s'est produite lors de l'obtention des documents.")
      }
    },
    updateDocumentCounter() {
      $(this.documentCounterSelector).text(this.files.length);
    },
    async uploadFiles(files) {
      for (const ix in files) {
        if(ix != "length" && ix != "item"){

          let formData = new FormData();
          formData.append(`document`, files[ix]);

          for (const key in this.additionnalData) {
            formData.append(`additionnal_data[${key}]`, this.additionnalData[key]);
          }

          try {
            let response = await $.ajax({
              url: `${this.endpointPrefix}/upload`,
              type: "POST",
              processData: false,
              contentType: false,
              dataType: "json",
              data: formData
            });

            this.files.push(response);
            this.updateDocumentCounter();

            toastr.success("Le document a été téléchargé avec succès.")
          } catch(err) {
            toastr.error("Une erreur s'est produite lors du téléchargement des documents.")
            console.error(err);
          }

        }
      }
    },
    viewSelectedFilesPrompt() {
      for (const file of this.selectedFiles) {
        window.open(`${this.endpointPrefix}/preview/${file.id}`)
      }
    },
    downloadOneDocument(file) {
      window.location.href = `${this.endpointPrefix}/download/${file.id}`;
    },
    downloadSelectedFiles() { // TODO: Possibilité de télécharger plusieurs documents en même temps.
      for (const file of this.selectedFiles) {
        window.location.href = `${this.endpointPrefix}/download/${file.id}`;
      }
    },
    deleteOneDocument(file) {
      this.selectedFiles = [];
      this.selectedFiles.push(file);
      this.deleteSelectedFilesPrompt();
    },
    deleteSelectedFilesPrompt() {
      let that = this;

      bootbox.dialog({
        title: "Suppression de documents",
        message: `Êtes-vous sûr de vouloir supprimer ${this.selectedFiles.length} document${this.selectedFiles.length == 1 ? '' : 's'}?`,
        buttons: {
          confirm: {
            label: "Supprimer",
            className: "red",
            callback: () => {
              that.deleteSelectedDocuments();
            }
          },
          cancel: {
            label: "Annuler",
            className: "secondary",
            callback: () => {

            }
          }
        }
      })
    },
    async deleteSelectedDocuments() {
      for (let ix = this.selectedFiles.length-1; ix >= 0; ix--) {
        const file = this.selectedFiles[ix] 
        try {
          await $.post(`${this.endpointPrefix}/delete`, {document_id: file.id});

          let ix = this.selectedFiles.findIndex(f => f.id == file.id);
          this.selectedFiles.splice(ix,1);
          
          ix = this.files.findIndex(f => f.id == file.id);
          this.files.splice(ix,1);

          this.updateDocumentCounter();
        } catch {
          toastr.error("Une erreur s'est produite lors de la suppression du document.")
        }
      }
    },
    toggleSelected(event, file) {
      if(this.multiSelectMode || event.ctrlKey){
        if(this.fileSelected(file)){
          let ix = this.selectedFiles.findIndex(f => f.id == file.id);
          this.selectedFiles.splice(ix,1);
        } else {
          this.selectedFiles.push(file);
        }
      } else {
        this.selectedFiles.splice(0, this.selectedFiles.length, file);
      }
    },
    triggerFileUpload() {
      this.$refs["file-uploader"].click();
    }
  },
}
</script>

<style lang="scss" scoped>
.file-thumbnail {
  height: 100px;

  img {
    width: 100%;
    height: 100px;
    object-fit: contain;
  }
}

.uploader {
  opacity: 0;
  position: absolute;
  pointer-events: none;
}

.add-document-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%; 
  height: 100%;
  font-size: 28px;
  border: 2px dashed #aaa;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 5px;

  &:hover {
    border: 2px dashed rgb(64, 146, 75);
    color: rgb(14, 83, 23);
  }
}

.file-title {
  word-break: break-all;
}

.file-item {
  width: 125px; 
  display: inline-block; 
  vertical-align: top; 
  position: relative;
  border-radius: 5px;
  padding: 3px;
  margin-top: 5px;
  margin-right: 5px;
  cursor: pointer;

  .file-select-box {
    top: 10px;
    left: 10px;
    position: absolute;
    display: none;
    font-size: 22px;
  }

  &:hover, &.active, &.selected {
    background-color: rgba($color: #000000, $alpha: 0.2);
  }
}

.file-multi-select .file-select-box {
  display: block;
}
</style>